import { input, signal } from '@angular/core';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { AuthStrategiesService, AuthStrategyType, DynamicComponentDirective, CoreWidgetComponent, DynamicComponentHelper, LocalMessageHandlerService, NgLetDirective } from '@core/frontend-shared';
import { ConfigService } from '@core/shared/config';
import { take } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@core/shared/config";
const _c0 = () => ({
  id: "common/users/autentication/top"
});
const _c1 = () => ({
  id: "common/users/autentication/bottom"
});
function UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr");
  }
}
function UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    const strategy_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("dynamicComponent", strategy_r1.componentInfo);
  }
}
function UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner");
  }
}
function UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_0_Template, 1, 0, "hr");
    i0.ɵɵconditionalCreate(1, UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_1_Template, 1, 1, "ng-container")(2, UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Conditional_2_Template, 1, 0, "ui-spinner");
  }
  if (rf & 2) {
    const strategy_r1 = ctx.$implicit;
    const ɵ$index_6_r2 = ctx.$index;
    i0.ɵɵconditional(ɵ$index_6_r2 > 0 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(strategy_r1.componentInfo ? 1 : 2);
  }
}
function UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_For_1_Template, 3, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const s_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵrepeater(s_r3);
  }
}
function UserAuthenticationStrategiesComponent_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " No enabled AuthStrategy for Authentication was found. ");
  }
}
function UserAuthenticationStrategiesComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UserAuthenticationStrategiesComponent_ng_template_1_Conditional_0_Template, 2, 0)(1, UserAuthenticationStrategiesComponent_ng_template_1_Conditional_1_Template, 1, 0);
  }
  if (rf & 2) {
    const s_r3 = ctx.$implicit;
    i0.ɵɵconditional((s_r3 == null ? null : s_r3.length) > 0 ? 0 : 1);
  }
}
export let UserAuthenticationStrategiesComponent = /*#__PURE__*/(() => {
  class UserAuthenticationStrategiesComponent {
    constructor(messages, config, strategiesService) {
      this.messages = messages;
      this.config = config;
      this.strategiesService = strategiesService;
      this.registrationEnabled = signal(false, ...(ngDevMode ? [{
        debugName: "registrationEnabled"
      }] : /* istanbul ignore next */[]));
      this.strategies = signal(null, ...(ngDevMode ? [{
        debugName: "strategies"
      }] : /* istanbul ignore next */[]));
      // TODO: should be handled by other solution. This generic wrapper does not know if password auth exists or not.
      this.resetPasswordEnabled = input(true, ...(ngDevMode ? [{
        debugName: "resetPasswordEnabled"
      }] : /* istanbul ignore next */[]));
      const strategies = strategiesService.getStrategiesOfType(AuthStrategyType.authenticate);
      this.strategies.set(strategies);
      strategies.forEach(s => {
        DynamicComponentHelper.loadComponent(s.entrypoint).pipe(take(1)).subscribe(componentInfo => {
          s.componentInfo = componentInfo;
          this.strategies.set([...strategies]);
        });
      });
    }
    static {
      this.ɵfac = function UserAuthenticationStrategiesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserAuthenticationStrategiesComponent)(i0.ɵɵdirectiveInject(i1.LocalMessageHandlerService), i0.ɵɵdirectiveInject(i2.ConfigService), i0.ɵɵdirectiveInject(i1.AuthStrategiesService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UserAuthenticationStrategiesComponent,
        selectors: [["user-authentication-strategies"]],
        inputs: {
          resetPasswordEnabled: [1, "resetPasswordEnabled"]
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        decls: 3,
        vars: 5,
        consts: [[3, "widget"], [3, "ngLet"], [4, "dynamicComponent"]],
        template: function UserAuthenticationStrategiesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "core-widget", 0);
            i0.ɵɵtemplate(1, UserAuthenticationStrategiesComponent_ng_template_1_Template, 2, 1, "ng-template", 1);
            i0.ɵɵelement(2, "core-widget", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("widget", i0.ɵɵpureFunction0(3, _c0));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngLet", ctx.strategies());
            i0.ɵɵadvance();
            i0.ɵɵproperty("widget", i0.ɵɵpureFunction0(4, _c1));
          }
        },
        dependencies: [NgLetDirective, DynamicComponentDirective, UiSpinnerComponent, CoreWidgetComponent],
        styles: ["[_nghost-%COMP%] >   *+*{margin-top:20px;display:block}\n\n/*# sourceMappingURL=authentication-strategies.component.ts-angular-inline--72.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return UserAuthenticationStrategiesComponent;
})();